// @ts-ignore
import { DividerProps } from '@/components/divider/types';
import { renameDomProps } from '@/utils/sanitizeDomProps';
import { sizeClass, widthClass } from './const';

export function Divider({
  size = 'large',
  border,
  width = 'half',
  className,
  ...rest
}: DividerProps) {
  // Resolve the class based on the provided prop, with a default fallback
  const resolvedSizeClass = sizeClass[size];
  const resolvedBorderClass = border ? 'border-y-1 border-black' : 'border-0';
  const resolvedWidthClass = widthClass[width];
  const renamedProps = renameDomProps(rest);
  return (
    <hr
      data-component-id="C003"
      aria-hidden="true"
      className={`smzh-divider ${resolvedSizeClass} ${resolvedBorderClass} ${resolvedWidthClass} ${className}`}
      {...renamedProps}
    />
  );
}
